import { useTranslation } from 'react-i18next';
import {
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer,
	BarChart,
	Bar
} from 'recharts';
import { useCommunityPartnerPartnersInsight } from 'src/hooks/useCommunityPartner';
import {
	Badge,
	Button,
	Card,
	LoadingContent,
	NoData
} from 'src/containers/Elements';
import { Colors } from 'src/types/Color';
import { useMemo, useState } from 'react';

const PartnerInsightChart = () => {
	const { t, i18n } = useTranslation();

	const { data: partnersInsight, isLoading } =
		useCommunityPartnerPartnersInsight();

	const [activeTab, setActiveTab] = useState<'views' | 'applied'>('views');

	// Build last 6 months array including current month
	const chartData = useMemo(() => {
		const now = new Date();
		const months: Date[] = [];
		for (let i = 5; i >= 0; i--) {
			months.push(new Date(now.getFullYear(), now.getMonth() - i, 1));
		}

		return months.map((d) => {
			const mi = partnersInsight?.monthlyInsights?.find(
				(m: any) =>
					m.year === d.getFullYear() && m.month === d.getMonth() + 1
			);
			return {
				date: d.toLocaleString(
					i18n.language === 'en' ? 'en-US' : 'de-DE',
					{ month: 'short' }
				),
				totalView: mi?.totalView || 0,
				totalApply: mi?.totalApply || 0
			};
		});
	}, [partnersInsight, i18n.language]);

	return (
		<div>
			<Card className="d-flex flex-column gap-3 py-4 my-5">
				{isLoading && (
					<div className="p-5">
						<LoadingContent />
					</div>
				)}
				{partnersInsight && (
					<div className="row g-2">
						<div className="col-12 ">
							<Badge
								color={Colors['association']}
								className="d-flex align-items-center gap-2 mt-2 p-2 fs-5 w-100 rounded-5 justify-content-between">
								<div className="d-flex gap-2 align-items-center">
									<span className="fs-2">
										{partnersInsight.totalViewAllTime || 0}
									</span>
									<div style={{ fontSize: '14px' }}>
										<span>
											{t(
												'label.total-view-since-job-were-published'
											)}
										</span>
									</div>
								</div>
							</Badge>
						</div>
						{/* <div className="col-12 col-md-6">
							<span className="text-primary">
								{t('label.totalApplies')}
							</span>
							<Badge
								color={Colors['green']}
								className="d-flex align-items-center gap-2 p-2 fs-5 w-100 mt-2 justify-content-between">
								<div className="d-flex gap-2 align-items-center">
									<span className="fs-2">
										{partnersInsight.totalApplyAllTime || 0}
									</span>
									<div className="d-flex flex-column">
										<span style={{ fontSize: '14px' }}>
											{t('label.views-in-past-year')}
										</span>
									</div>
								</div>
							</Badge>
						</div> */}
					</div>
				)}
				{!partnersInsight?.monthlyInsights?.length && !isLoading ? (
					<NoData />
				) : (
					<>
						{/* {partnersInsight?.monthlyInsights?.length ? (
							<div className="mb-3 d-flex gap-2">
								<Button
									color={
										activeTab === 'views'
											? Colors['primary']
											: Colors['white-green']
									}
									onClick={() => setActiveTab('views')}>
									{t('label.views')}
								</Button>
								<Button
									color={
										activeTab === 'applied'
											? Colors['primary']
											: Colors['white-green']
									}
									onClick={() => setActiveTab('applied')}>
									{t('label.applied')}
								</Button>
							</div>
						) : null} */}
						{partnersInsight?.monthlyInsights?.length ? (
							<div style={{ marginLeft: 0 }}>
								<ResponsiveContainer width="100%" height={340}>
									<BarChart
										data={chartData}
										barCategoryGap={
											chartData.length <= 2
												? '40%'
												: '10%'
										}
										barGap={chartData.length <= 2 ? 20 : 4}
										margin={{
											top: 20,
											right: 30,
											left: 0,
											bottom: 20
										}}>
										<CartesianGrid strokeDasharray="3 3" />
										<XAxis
											dataKey="date"
											tick={{
												fontWeight: 600,
												fontSize: 14
											}}
										/>
										<YAxis
											tick={{
												fontWeight: 600,
												fontSize: 14
											}}
										/>
										<Tooltip
											cursor={{
												fill: '#e6f4ea',
												opacity: 0.25
											}}
											itemStyle={{
												color: '#3a5a40',
												fontWeight: 500
											}}
											labelStyle={{
												color: '#588157',
												fontWeight: 700
											}}
											formatter={(value) => [
												String(value),
												t(
													activeTab === 'views'
														? 'label.views'
														: 'label.applied'
												)
											]}
										/>
										<Legend
											wrapperStyle={{
												fontWeight: 500,
												fontSize: 14
											}}
										/>
										<Bar
											dataKey="totalView"
											fill="#3b82f6"
											name={`${t('label.views')}`}
											barSize={40}
											strokeWidth={1}
										/>
									</BarChart>
								</ResponsiveContainer>
							</div>
						) : null}
					</>
				)}
			</Card>
		</div>
	);
};

export default PartnerInsightChart;
